module.exports = __webpack_public_path__ + "img/asc-desc.82b94175.svg";